import React from 'react';
import { Link } from 'lib/link';
import PropTypes from 'prop-types';

import { getCellRendererProps } from './getCellRendererProps';

const LinkRendererV2 = ({ params, value, ...other }) => {
  const linkProps = getCellRendererProps(other);
  const href = `http://${other.data.make}.com`;

  const cellLinkClass = 'ag-cell__link ag-cell__text--truncate';

  return <Link className={cellLinkClass} href={href} text={value} data-testid="Link" {...linkProps} />;
};

LinkRendererV2.propTypes = {
  /** Row data  */
  params: PropTypes.any,
  /** Link text */
  value: PropTypes.string,
};

export { LinkRendererV2 };
